import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import OpenLogin, {OPENLOGIN_NETWORK_TYPE} from "@toruslabs/openlogin"
import React, {useContext, useCallback, useState, useRef, MouseEvent} from "react"
import {Link, useNavigate} from "react-router-dom"
import {AppConfig} from "../../../App.config"
import {ProfileContext} from "../../../context/Profile.context"
import {DownloadDesktopApp} from "../DownloadDesktopApp"
import {BackendContext} from "../../../context/BackendContext"
import {UIHelperContext} from "../../../context/UIHelper.context"
import {clearIPFSOrbit, getOrbitAddress, getOrbitConfig} from "../../../functions/ipfs-orbit"
import {useAPI} from "../../../hooks/useAPI"
import {AuthContext} from "../../../context/Auth.context"
import logo from "../../../assets/degit.png"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faCirclePlus, faSearch} from "@fortawesome/free-solid-svg-icons"
import {ProfileButton} from "../ProfileButton"
import styles from "./index.module.scss"

export const NavBar = () => {
  const {keys, authMethod} = useContext(AuthContext)
  const [openProfile, setOpenProfile] = useState(false)
  const [openDownloadDesktopPanel, setOpenDownloadDesktopPanel] = useState(false)
  const [isHideSearchIcon, setIsHideSearchIcon] = useState(false)
  const navigate = useNavigate()
  const profileButton = useRef<HTMLDivElement | null>(null)

  const onClickProfile = useCallback((_: MouseEvent) => {
    setOpenProfile(true)
  }, [])

  const onCloseProfile = useCallback(() => {
    setOpenProfile(false)
  }, [])

  const onSignOut = useCallback(async () => {
    if (authMethod == null) {
      return
    }

    switch (authMethod) {
      case "web3auth":
        try {
          const openLogin = new OpenLogin({
            clientId: AppConfig.openLoginClientId,
            network: AppConfig.openLoginNetwork as OPENLOGIN_NETWORK_TYPE,
          })
          await openLogin.init()
          await openLogin.logout()
          await clearIPFSOrbit()
          localStorage.removeItem("method")
          navigate("/")
          window.location.reload()
        } catch (e) {
        }
        break
      case "phantom":
        await clearIPFSOrbit()
        localStorage.removeItem("method")
        localStorage.removeItem("signedMessage")
        navigate("/")
        window.location.reload()
        break
      default:
        break
    }
  }, [authMethod, navigate])

  const onClickAddRepo = useCallback(async () => {
    navigate("/repos/new")
  }, [navigate])

  const onClickDownloadDeGit = useCallback(() => {
    setOpenDownloadDesktopPanel(true)
  }, [])

  const onCloseDownloadDeGit = useCallback(() => {
    setOpenDownloadDesktopPanel(false)
  }, [])

  const onTyping = useCallback((e: any) => {
    const value = e.target.value
    if (!value) {
      setIsHideSearchIcon(false)
      return
    }
    setIsHideSearchIcon(true)
  }, [])

  return (
    <div className={styles.MenuContainer}>
      <div className={styles.Logo}>
        <Link to="/">
          <img src={logo} alt="DeGit Logo"/>
        </Link>
      </div>

      <div className={styles.SearchBar}>
        <input className={styles.SearchInput}
               onInput={onTyping}
               placeholder="Search"
        />
        {
          isHideSearchIcon ? null : <FontAwesomeIcon icon={faSearch} className={styles.SearchIcon}/>
        }
      </div>

      <div className={styles.Grow}>
      </div>

      <div className={styles.NewRepo} onClick={onClickAddRepo}>
        <FontAwesomeIcon icon={faCirclePlus} className={styles.AddButton}/>
        <div>Create Repo</div>
      </div>

      <div onClick={onClickProfile} ref={profileButton}>
        <ProfileButton keys={keys}/>
      </div>

      <Menu open={openProfile}
            anchorEl={profileButton.current}
            onClick={onCloseProfile}
            onClose={onCloseProfile}
            classes={{paper: styles.ProfileMenuPaper, list: styles.ProfileMenuList}}
            disableAutoFocusItem={true}
            transformOrigin={{vertical: "top", horizontal: 150}}
      >
        <MenuItem classes={{root: styles.MenuItemRoot}} component={Link} to={"/profile"}>
          Profile
        </MenuItem>

        <hr/>

        <MenuItem classes={{root: styles.MenuItemRoot}}>
          Documentation
        </MenuItem>

        <hr/>

        <MenuItem classes={{root: styles.MenuItemRoot}} onClick={onClickDownloadDeGit}>
          Download DeGit Desktop
        </MenuItem>

        <hr/>

        <MenuItem classes={{root: styles.MenuItemRoot}} onClick={onSignOut}>
          Sign Out
        </MenuItem>
      </Menu>

      <DownloadDesktopApp open={openDownloadDesktopPanel}
                          onClose={onCloseDownloadDeGit}
      />
    </div>
  )
}
